/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Contato } from '../usuario/types';

const getContatosPorEmpresasId = (empresasId: number): AxiosPromise<Contato[]> => xhr.get(`/empresas/${empresasId}/contatos`);

export default getContatosPorEmpresasId;
